import { ClassProvider } from '@angular/core';
import { DataLineageDiagramStore, DataLineageDiagramQuery } from '../../state/data-lineage-diagram';
import { DataLineageDiagramStoreService } from '../../state/data-lineage-diagram/data-lineage-diagram-store.service';
import { DataLineageDiagramService, DataLineageDiagramDataService } from '../data-lineage-diagram';

export const DataLineageDiagramServices: Array<ClassProvider['useClass']> = [
  DataLineageDiagramStore,
  DataLineageDiagramQuery,
  DataLineageDiagramStoreService,
  DataLineageDiagramService,
  DataLineageDiagramDataService,
];
